<template>
  <div
  >
    <document-container
        v-for="product in response"
        :key="product.ids.isin"
        :logo="logo"
        documentType="tmc-export"
    >

      <div
          slot="raw-header"
      >
        <img :src="logo" alt="" class="logo">

        <div class="header">
          <pagetitle
              :data="{title: product.enriched.displayName || product.name || product.ids.isin}"
          ></pagetitle>
        </div>

      </div>

      <div
          slot="raw-body"
          class="page-block"
      >
        <div class="tmc-info">
          <div>
            <strong>WKN:</strong> {{ product.ids.wkn }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>ISIN:</strong> {{ product.ids.isin }}&nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;
            <strong>Stand:</strong>
            <i>{{ time }}</i>
          </div>
          <template v-if="product.enriched.tmc.watchlist.check.tmc.displayInfoText">
            <br>
            <i
                :class="`fa ${product.enriched.tmc.watchlist.check.tmc.conflict ? 'fa-exclamation-circle tmc-error' : 'fa-check-circle tmc-success'}`"></i> {{ product.enriched.tmc.watchlist.check.tmc.info }}
          </template>
        </div>

        <table class="table is-narrow">
          <thead>
          <tr>
            <th style="width:30%">Name</th>
            <th style="width:35%">{{ product.enriched.tmc.watchlist.check.product.label }}</th>
            <th style="width:35%">{{ product.enriched.tmc.watchlist.check.reference.label }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="row in product.enriched.tmc.watchlist.check.tmc.criteria"
              :class="row.conflict ? 'tmc-row-conflict': 'tmc-row-success'">
            <td>
              <i :class="`fa ${row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'}`"></i>
              &nbsp;
              {{ row.label }}
            </td>
            <td>
              <i :class="row.positive ? 'tmc-success' : 'tmc-neutral'" class="fa fa-plus-circle"></i> {{ row.positive ? row.positive.join(', ') : '—' }}
              <br>
              <i :class="row.negative ? 'tmc-error' : 'tmc-neutral'" class="fa fa-minus-circle"></i> {{ row.negative ? row.negative.join(', ') : '—' }}
            </td>

            <td v-if="$route.query.comparisonMode === 'REFERENCE_TMC_GROUP'">
              <i :class="row.referencePositive ? 'tmc-success' : 'tmc-neutral'" class="fa fa-plus-circle"></i> {{ row.referencePositive ? row.referencePositive.join(', ') : '—' }}
              <br>
              <i :class="row.referenceNegative ? 'tmc-error' : 'tmc-neutral'" class="fa fa-minus-circle"></i> {{ row.referenceNegative ? row.referenceNegative.join(', ') : '—' }}
            </td>

            <td v-if="$route.query.comparisonMode === 'REFERENCE_PROVIDER' || $route.query.comparisonMode === 'CUSTOMER'">
              <template v-if="row.referencePositive">{{ row.referencePositive.join(', ') }}</template>
              <template v-else>—</template>
            </td>
          </tr>
          </tbody>
        </table>
      </div>

<!--      <div-->
<!--          slot="raw-body"-->
<!--          class="page-block"-->
<!--      >-->
<!--        <div class="tmc-info">-->
<!--          <template>-->
<!--            <i-->
<!--                :class="`fa ${product.enriched.tmc.watchlist.check.sustainability.conflict ? 'fa-remove tmc-error' : 'fa-check-circle tmc-success'}`"></i>-->
<!--            {{ product.enriched.tmc.watchlist.check.sustainability.info }}-->
<!--          </template>-->
<!--        </div>-->
<!--        <table class="table is-narrow">-->
<!--          <thead>-->
<!--          <tr v-if="environment === 'hauck'">-->
<!--            <th style="width:30%">Kategorie</th>-->
<!--            <th style="width:35%">Ausprägung Produkt</th>-->
<!--            <th style="width:35%">{{ product.enriched.tmc.watchlist.check.reference.label }}</th>-->
<!--          </tr>-->
<!--          <tr v-else>-->
<!--            <th style="width:30%">Name</th>-->
<!--            <th style="width:35%">Kriterien</th>-->
<!--            <th style="width:35%">{{ product.enriched.tmc.watchlist.check.reference.label }}</th>-->
<!--          </tr>-->
<!--          </thead>-->
<!--          <tbody>-->
<!--          <tr v-for="row in product.enriched.tmc.watchlist.check.sustainability.criteria"-->
<!--              :class="row.conflict ? 'tmc-row-conflict': 'tmc-row-success'">-->
<!--            <td>-->
<!--              <i :class="`fa ${row.conflict ? 'fa-remove tmc-error' : 'fa-check tmc-success'}`"></i> {{ row.label }}-->
<!--            </td>-->
<!--            <td>-->
<!--              <template v-if="row.criteria && row.criteria.length !== 0">-->
<!--                <div v-for="cell in row.criteria">{{ cell }}</div>-->
<!--              </template>-->
<!--              <template v-else>-&#45;&#45;</template>-->
<!--            </td>-->
<!--            <td>-->
<!--              <template v-if="row.reference && row.reference.length !== 0">-->
<!--                <div v-for="cell in row.reference">{{ cell }}</div>-->
<!--              </template>-->
<!--              <template v-else>-&#45;&#45;</template>-->
<!--            </td>-->
<!--          </tr>-->
<!--          </tbody>-->
<!--        </table>-->
<!--      </div>-->

      <div
          slot="raw-body"
          class="page-block"
      >
        <h2>Nachhaltigkeit</h2>
        <table class="table is-narrow">
          <tr v-for="(value, key) in esgTranslations">
            <td style="width:20%">{{ value }}</td>
            <td v-if="key !== 'paiCluster'">{{ product.enriched.tmc.product.derived.sustainability[key] || '—' }}</td>
            <td v-if="key === 'paiCluster'"
                v-html=" _.get(product.enriched.tmc.product.derived.sustainability, 'paiCluster', []).length !== 0 ? product.enriched.tmc.product.derived.sustainability.paiCluster.join('<br>') : '—'"></td>
          </tr>
        </table>
      </div>

      <div
          slot="raw-body"
          class="page-block"
      >
        <h2>Kommentar</h2>
        <div>{{ _.get(product.enriched.tmc.watchlist.check, 'comment', false) || '—' }}</div>
      </div>

    </document-container>

    <document-container
        v-if="ignoredProducts.length > 0"
        :key="'ignored'"
        :logo="logo"
        documentType="tmc-export"
    >
      <div
          slot="raw-header"
      >
        <img :src="logo" alt="" class="logo">

        <div class="header">
          <pagetitle
              :data="{title: 'Produkte ohne Zielmarktabgleich'}"
          ></pagetitle>
        </div>

      </div>
      <div
          slot="raw-body"
          class="page-block"
      >
        <h2>Für folgende Werte konnte kein Abgleich erstellt werden:</h2>
      </div>

      <div
          slot="raw-body"
          class="page-block"
          v-for="product in ignoredProducts"
      >
        ISIN:
        <strong>{{ product.isin }}</strong> | Bezeichnung:
        <strong>{{ product.name }}</strong>
      </div>
    </document-container>
  </div>
</template>

<script>
import DocumentContainer
  from '../document/DocumentContainer'
import BlockMixin
  from '../block/BlockMixin'
import ProductService
  from "../../service/ProductService"
import TokenService
  from "../../service/TokenService"

export default {
  components: {
    DocumentContainer,
  },

  name: 'TmcExport',

  data() {
    return {
      response: null,
      template: null,
      ignoredProducts: [],
      esgTranslations: {
        preferences: 'Präferenzen',
        focus: 'Schwerpunkt',
        labels: 'Labels',
        paiCluster: 'PAIs',
        esg: 'ESG',
        eco: 'ECO'
      }
    }
  },

  mixins: [BlockMixin],

  head: {
    link: function () {
      return [
        {
          rel: 'stylesheet',
          href: `/config/test/style/tmc_export.css`,
        },
      ]
    },
  },

  props: {
    environment: {
      type: String,
    },
    dq: {
      type: String,
    },
    watchlistId: {
      type: String,
    },
    appInstance: {
      type: String,
      required: false,
    },
  },

  methods: {},

  async created() {
    let token

    if (this.$route.query.token) {
      token = this.$route.query.token
    } else {
      token = await TokenService.checkToken()
    }

    if (this.dq) {
      ProductService.getTmcExport(
          this.environment,
          this.appInstance,
          token,
          {
            productDq: this.dq,
            mode: this.$route.query.comparisonMode,
            referenceTmc: this.$route.query.tmc,
          },
      ).then(res => {
        this.response = res.data.data.length ? res.data.data : [res.data.data]
      })
    } else {
      ProductService.getMultiTmcExport(
          this.environment,
          this.appInstance,
          token,
          this.watchlistId,
          this.$route.query.comparisonMode,
      ).then(res => {
        let response = res.data.data
        this.response = []
        for (let productType in response) {
          for (let product of response[productType]) {
            this.response.push(product)
          }
        }
      })
    }
  },

  computed: {
    logo() {
      return '/config/' + this.environment + '/images/logo.png'
    },
    time() {
      return this.moment().format('DD. MMMM YYYY')
    },
  },
}
</script>

<style lang="scss">
.tmc-info {
  font-size: 14px;
  margin-bottom: 20px;

}

.tmc-row-conflict {
  background-color: #ffe7e7;
}

.tmc-export {
  .logo {
    width: 140px !important;;
  }
  .header {
    margin-top: 50px !important;

    .page-title {
      margin-bottom: 20px !important;
      h1{
        white-space: normal !important;;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// TmcMultiExport.vue?ef6d14a0